import { render, staticRenderFns } from "./NotifCert.vue?vue&type=template&id=61d71fe4&"
import script from "./NotifCert.vue?vue&type=script&lang=js&"
export * from "./NotifCert.vue?vue&type=script&lang=js&"
import style0 from "./NotifCert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports